import {createStore, combineReducers} from 'redux';
import {compareBucket} from './../reducers';

export const createReduxStore = (initStore) => {
    return createStore(combineReducers({compareBucket}), initStore);
};



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/CompareBucketRedux/storages/ReduxStore.js